import { Link } from 'react-router-dom'
import { Users, Mail, BarChart3, UserCog, FileText, Bug } from 'lucide-react'

const cards = [
  {
    to: '/admin/users',
    icon: Users,
    title: 'Users',
    description: 'Manage registered users',
  },
  {
    to: '/admin/invites',
    icon: Mail,
    title: 'Invites',
    description: 'Invite codes and access control',
  },
  {
    to: '/admin/usage',
    icon: BarChart3,
    title: 'Usage',
    description: 'Platform usage and quotas',
  },
  {
    to: '/admin/emulate',
    icon: UserCog,
    title: 'Emulate',
    description: 'Emulate user sessions',
  },
  {
    to: '/admin/docs',
    icon: FileText,
    title: 'Docs',
    description: 'Manage public documentation',
  },
  {
    to: '/admin/bugs',
    icon: Bug,
    title: 'Bug Reports',
    description: 'View user-submitted bug reports',
  },
] as const

export default function AdminHome() {
  return (
    <div className="grid grid-cols-2 gap-4">
      {cards.map(({ to, icon: Icon, title, description }) => (
        <Link
          key={to}
          to={to}
          className="glass rounded-xl p-8 hover:border-cyan-500/30 transition-all duration-150 group cursor-pointer"
        >
          <div className="w-12 h-12 rounded-xl bg-cyan-500/10 flex items-center justify-center mb-4 group-hover:bg-cyan-500/15 transition-colors duration-150">
            <Icon className="w-6 h-6 text-cyan-500/70 group-hover:text-cyan-400 transition-colors duration-150" />
          </div>
          <div className="font-mono text-base text-slate-200 mb-1">{title}</div>
          <div className="font-mono text-sm text-slate-500">{description}</div>
        </Link>
      ))}
    </div>
  )
}
